import React from 'react';
import { ACTIONS } from '../../../config/api';

// SVG Icons
const BuyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </svg>
);

const SellIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6" />
  </svg>
);

const MonitorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

// Icon and color mapping for actions
const ACTION_CONFIG = {
  BUY: { icon: <BuyIcon />, badgeClass: 'badge-success' },
  SELL: { icon: <SellIcon />, badgeClass: 'badge-error' },
  NONE: { icon: <MonitorIcon />, badgeClass: 'badge-ghost' },
};

/**
 * ActionToggleSelector - Toggle button group for selecting BUY/SELL/NONE actions
 */
export const ActionToggleSelector = ({
  value,
  onChange,
  disabled = false,
  showNone = false,
}) => {
  const actions = showNone ? ['BUY', 'SELL', 'NONE'] : ['BUY', 'SELL'];

  return (
    <div className="join w-full">
      {actions.map((action) => {
        const config = ACTION_CONFIG[action];
        const isSelected = value === action;
        return (
          <button
            key={action}
            type="button"
            className={`join-item btn flex-1 ${isSelected ? (action === 'BUY' ? 'btn-success' : action === 'SELL' ? 'btn-error' : 'btn-ghost btn-active') : 'btn-ghost'}`}
            onClick={() => onChange(action)}
            disabled={disabled}
          >
            {config.icon}
            <span className="ml-1">{action}</span>
          </button>
        );
      })}
    </div>
  );
};

/**
 * ActionDropdownSelector - Dropdown for selecting actions
 */
export const ActionDropdownSelector = ({
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  label = 'Action',
  showNone = false,
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const actions = showNone
    ? Object.entries(ACTIONS)
    : Object.entries(ACTIONS).filter(([key]) => key !== 'NONE');

  return (
    <div className="fieldset w-full">
      <label className="label">
        <span className="text-sm">{label}{required && <span className="text-error">*</span>}</span>
      </label>
      <select
        className={`select select w-full ${error ? 'select-error' : ''}`}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={required}
      >
        <option value="" disabled>Select action</option>
        {actions.map(([key, { label: actionLabel }]) => (
          <option key={key} value={key}>{actionLabel}</option>
        ))}
      </select>
      {error && <label className="label"><span className="text-xs text-base-content/60 text-error">{error}</span></label>}
    </div>
  );
};

/**
 * ActionChip - Display-only badge showing action
 */
export const ActionChip = ({ action }) => {
  const config = ACTION_CONFIG[action] || ACTION_CONFIG.NONE;
  return (
    <span className={`badge ${config.badgeClass} gap-1`}>
      {config.icon}
      {action}
    </span>
  );
};

export default { ActionToggleSelector, ActionDropdownSelector, ActionChip };
